import classNames from 'classnames';
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import './CourseTitle.scss';

interface ICourseTitleProps {
  course: ICourse;
  className?: string;
}

const CourseTitle = ({ course, className }: ICourseTitleProps) => (
  <div className={classNames('CourseTitleAndPublicationStatus', className)}>
    <span>{course.title}</span>
    {!course.published && (
      <OverlayTrigger
        overlay={
          <Popover id={`course-unpublished-tooltip`}>
            <Popover.Content>Unpublished</Popover.Content>
          </Popover>
        }
      >
        <span className="material-icons-outlined pointer unpublished">unpublished</span>
      </OverlayTrigger>
    )}
  </div>
);

export default CourseTitle;
